import { Box } from '@mantine/core'
import React, { useMemo } from 'react'
import { sanitizeLessonHtml } from 'src/utils/lessonHtml'

type LessonHtmlPreviewProps = {
	html?: string | null
	/** A title shown on one line, after a bold lead-in, as the app's exercise card does. */
	inline?: boolean
	'data-testid'?: string
}

/** A lesson text drawn the way learners see it: bold, colors and lists, never raw tags. */
function LessonHtmlPreview({
	html,
	inline,
	'data-testid': testId,
}: LessonHtmlPreviewProps) {
	const safe = useMemo(() => sanitizeLessonHtml(html), [html])
	return (
		<Box
			component={inline ? 'span' : 'div'}
			data-testid={testId}
			sx={{
				color: '#0f1729',
				fontSize: 14,
				lineHeight: '20px',
				wordBreak: 'break-word',
				'p, ul, ol, blockquote, pre': { margin: '0 0 8px' },
				'> :last-child': { marginBottom: 0 },
				'ul, ol': { paddingLeft: 20 },
				'h1, h2, h3, h4, h5, h6': {
					margin: '0 0 8px',
					fontSize: 14,
					fontWeight: 700,
				},
				'strong, b': { fontWeight: 700 },
				a: { color: '#1d4ed8' },
				mark: { background: '#fef08a' },
				img: { maxWidth: '100%', borderRadius: 8 },
			}}
			// Sanitized above: an allowlist of tags, no event attributes, no script or javascript: links.
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{ __html: safe }}
		/>
	)
}

export default LessonHtmlPreview
